module.exports = __webpack_public_path__ + "static/media/theme_park.2cac6c84.svg";